import { useInView } from "react-intersection-observer";
import React from "react";

import CountUp from "react-countup";
import { motion } from "framer-motion";

import { fadeIn } from "../variants";

const About = () => {
  const [ref, inView] = useInView({ threshold: 0.5 });
  return (
    <section className="section" id="about" ref={ref}>
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-screen">
          <motion.div
            variants={fadeIn("right", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 bg-about bg-contain bg-no-repeat h-[640px] min-blend-lighten bg-top lg:h-[500px] max-sm:h-[300px]"
          ></motion.div>
          <motion.div
            variants={fadeIn("up", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.7 }}
            className="flex-1"
          >
            <h2 className="h2 text-accent">About Me</h2>
            <h3 className="h3 mb-4 lg:h4 md:mb-8 leading-tight sm:leading-7">
              I'm a skilled React JS developer with a focus on dynamic web apps.
              Expert in HTML5, CSS3, JS, and WordPress, I excel in Tailwind CSS,
              Sass, Bootstrap, and responsive design, ensuring exceptional user
              experiences.
            </h3>
            <p className="mb-6">
              My goal is to become a full stack engineer, learn new languages,
              and embark on an extensive career in the computer industry.
            </p>
            <div className="flex gap-x-6 lg:gap-x-10 mb-12">
              <div>
                <div className="text-[40px] font-tertiary text-gradient mb-2">
                  {inView ? <CountUp start={0} end={15} duration={3} /> : null}
                </div>
                <div className="font-primary text-sm tracking-[2px]">
                  month of
                  <br /> Experienced
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
